import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";
import { BASE_URL } from "constants";

const scanServices = createApi({
  reducerPath: "scanApi",
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
  }),
  tagTypes: ["scan"],
  endpoints: (builder) => ({
    getScanTokenInfo: builder.query({
      query: (token) => `/schedule/get?scanTicketToken=${token}`,
      providesTags: ["scan"],
    }),
    getScanDetail: builder.mutation({
      query: (body) => ({
        url: "getScanDetail",
        method: "POST",
        body,
      }),
    }),
    redeemTicketOrAddons: builder.mutation({
      query: (body) => ({
        url: "redeemTicketOrAddons",
        method: "POST",
        body,
      }),
      invalidatesTags: ["scan"],
    }),
  }),
});

export const {
  useGetScanTokenInfoQuery,
  useGetScanDetailMutation,
  useRedeemTicketOrAddonsMutation,
} = scanServices;

export default scanServices;
